import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b6b7fa0c&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=b6b7fa0c&lang=scss&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7fa0c",
  null
  
)

export default component.exports